import styled from 'styled-components';

import { FontWeights, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	padding-bottom: 12px;
	margin-bottom: 24px;

	${minWidth('tablet')} {
		margin-bottom: 16px;
	}

	${minWidth('desktop')} {
		margin-bottom: 24px;
	}

	${minWidth('desktopLarge')} {
		margin-bottom: 36px;
	}
`;

export const CarouselWrapper = styled.ul<{ $gap: number; $leftOffset: string }>`
	list-style: none;
	margin: 0;
	padding: 0;
	z-index: 0;
	display: flex;
	transform: translateX(${p => p.$leftOffset});
	transition: transform 0.2s ease-in-out;
	gap: ${p => p.$gap}px;
`;

// A lone slide takes its container's width, capped at the widest this card type is ever drawn,
// instead of the measured pixel width. Those widths divide the *window* (less the sidebar),
// deliberately ignoring the page's own horizontal padding, since a carousel bleeds toward the
// edge and the fractional card count leaves a peek that hides the difference. With nothing to
// scroll there's no peek to hide it, and the card sits narrower than the column beside it. The
// cap matters as much as the fill: a container that is the narrow content column on a phone is
// the whole page on a desktop, where an uncapped card would balloon far past any real card.
export const CarouselSlide = styled.li<{
	$height: string;
	$width: string;
	$isOnlySlide?: boolean;
	$maxWidth: number;
}>`
	min-height: ${p => p.$height};
	${p =>
		p.$isOnlySlide
			? `
	max-width: ${p.$maxWidth}px;
	min-width: 0;
	width: 100%;
	`
			: `min-width: ${p.$width};`}
`;

export const TitleContainer = styled.div<{ $showTitle: boolean }>`
	align-items: center;
	display: flex;
	justify-content: ${p => (p.$showTitle ? 'space-between' : 'right')};
`;

export const Title = styled(Text).attrs({
	el: 'h2',
	styleAs: 'h5',
	color: 'white',
	weight: FontWeights.Regular,
})`
	margin-top: 0;
	margin-bottom: 16px;
`;

export const RightAlignedContainer = styled.div`
	align-items: center;
	display: flex;
`;
